<template>
    <div class="overview-container" v-if="this.selectedPublisher">
        <OverviewBox :title="$t('admin.overview.general_stats_title')" v-bind:icon="statsIcon" class="general-stats-box">
            <GeneralStatsBox :publisher="this.selectedPublisher" />
        </OverviewBox>
        <OverviewBox :title="$t('admin.overview.maps_title')" v-bind:icon="mapsIcon" class="maps-box">
            <MapsBox :publisher="this.selectedPublisher" />
        </OverviewBox>
        <OverviewBox :title="$t('admin.overview.notifications_title')" v-bind:icon="notificationsIcon" class="notifications-box">
            <MessageCenterBox :publisherId="this.selectedPublisher.id" :userId="this.currentUser.uid" />
        </OverviewBox>
        <OverviewBox :title="$t('admin.overview.news_feed')" v-bind:icon="newsIcon" class="news-box">
            <NewsFeedBox />
        </OverviewBox>
        <OverviewBox :title="$t('admin.overview.contact_us')" v-bind:icon="contactUsIcon" class="contact-us-box">
            <ContactUsBox />
        </OverviewBox>
    </div>
</template>

<script>
import OverviewBox from './OverviewBox'
import GeneralStatsBox from './box/GeneralStatsBox'
import MapsBox from './box/MapsBox'
import MessageCenterBox from './box/MessageCenterBox'
import NewsFeedBox from './box/NewsFeedBox'
import ContactUsBox from './box/ContactUsBox'

export default {
    components: {
        OverviewBox,
        GeneralStatsBox,
        MapsBox,
        MessageCenterBox,
        NewsFeedBox,
        ContactUsBox
    },
    
    data() {
        return {
            selectedPublisher: this.$store.state.currentPublisher,
            currentUser: this.$store.state.currentUser,
            statsIcon: require("@/assets/icons/StatsIcon.png"),
            mapsIcon: require("@/assets/icons/MapsIcon.png"),
            notificationsIcon: require("@/assets/icons/NotificationsIcon.png"),
            newsIcon: require("@/assets/icons/NewsIcon.png"),
            contactUsIcon: require("@/assets/icons/ContactUsIcon.png")
        }
    },

    mounted() {
        this.$store.subscribe( (mutation) => {
            if (mutation.type == "setCurrentPublisher") {
                this.selectedPublisher = mutation.payload;
            }
        });
    }
}
</script>

<style scoped>
.overview-container {
    display: grid;
    grid-template-columns: 7% 7% 7% 7% 7% 7% 7% 7% 7% 7% 7% 7%;
    grid-template-rows: 50% 50%;
    grid-template-areas: "generalStats generalStats generalStats generalStats maps maps maps maps notifications notifications notifications notifications" 
        "news news news news news news contactUs contactUs contactUs contactUs contactUs contactUs";
    row-gap: 16px;
    column-gap: 16px;
    justify-content: center;
    padding-bottom: 16px;
}

.general-stats-box {
    grid-area: generalStats;
}

.maps-box {
    grid-area: maps;
}

.notifications-box {
    grid-area: notifications;
}

.news-box {
    grid-area: news;
}

.contact-us-box {
    grid-area: contactUs;
}
</style>